import {
  createEntityAdapter,
  createSlice,
  createAsyncThunk,
  createSelector,
} from '@reduxjs/toolkit';

import { fetchGetCampaigns } from 'api/campaignApi';
import { emptyCampaign } from 'constants/campaignConstants';
import { campaignStatuses } from 'constants/statuses';
import showSnackbarError from 'utils/showSnackbarError';

const pendingCampaignsAdapter = createEntityAdapter({
  selectId: (campaign) => campaign.id,
});

const initialState = {
  pendingCampaigns: pendingCampaignsAdapter.getInitialState(),
  isLoading: false,
  isLoaded: false,
};

export const getPendingCampaigns = createAsyncThunk(
  'campaigns/getPendingCampaigns',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const {
        CAMPAIGN_CREATED,
        PENDING_ART_BRIEF,
        PENDING_PAYMENT_METHOD,
        PENDING_ART_PROOF,
        PENDING_ART_PROOF_APPROVAL,
        ART_PROOF_REJECTED,
        ART_PROOF_APPROVED,
        LOCATION_REJECTED,
        PRODUCTION_IN_PROGRESS,
        CANCELED,
      } = campaignStatuses;
      const withoutDraftStatuses = `${CAMPAIGN_CREATED},${PENDING_ART_BRIEF},${PENDING_PAYMENT_METHOD},${PENDING_ART_PROOF},${PENDING_ART_PROOF_APPROVAL},${ART_PROOF_REJECTED},${ART_PROOF_APPROVED},${LOCATION_REJECTED},${PRODUCTION_IN_PROGRESS},${CANCELED}`;

      const { campaigns } = await fetchGetCampaigns({
        campaignStatus: withoutDraftStatuses,
        perPage: 5,
        page: 1,
      });

      return campaigns;
    } catch (e) {
      dispatch(showSnackbarError(e.message, e.stack));

      return rejectWithValue(e.message);
    }
  }
);

const menuCampaignsSlice = createSlice({
  name: 'menuCampaigns',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPendingCampaigns.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPendingCampaigns.fulfilled, (state, action) => {
        pendingCampaignsAdapter.setMany(state.pendingCampaigns, action.payload);
        state.isLoading = false;
        state.isLoaded = true;
      })
      .addCase(getPendingCampaigns.rejected, (state) => {
        state.isLoading = false;
        state.isLoaded = true;
      });
  },
});

const { selectAll: selectAllPending, selectById: selectByIdPending } =
  pendingCampaignsAdapter.getSelectors(
    (state) => state.menuCampaigns.pendingCampaigns
  );

const allPending = createSelector(selectAllPending, (state) => state);

const byIdPending = (id) =>
  createSelector(
    (state) => state,
    (state) => selectByIdPending(state, id) || emptyCampaign
  );

const selectSelf = (state) => state.menuCampaigns;
const isLoading = createSelector(selectSelf, (state) => state.isLoading);
const isLoaded = createSelector(selectSelf, (state) => state.isLoaded);

export const MenuCampaignsSelectors = {
  allPending,
  byIdPending,
  isLoading,
  isLoaded,
};

export default menuCampaignsSlice.reducer;
